/**
 * Sliding-window median filter.
 * Returns null until the window is full, then the median of the last N samples.
 */
export default class MedianFilter {
  constructor(windowSize) {
    this.windowSize = windowSize;
    this.buffer = new Array(windowSize).fill(0);
    this.head = 0;
    this.count = 0;
  }

  filter(sample) {
    this.buffer[this.head] = sample;

    this.head += 1;
    if (this.head === this.windowSize) {
      this.head = 0;
    }

    if (this.count < this.windowSize) {
      this.count += 1;

      if (this.count < this.windowSize) {
        return null;
      }
    }

    const values = new Array(this.windowSize);
    let idx = this.head;

    for (let i = 0; i < this.windowSize; i += 1) {
      values[i] = this.buffer[idx];
      idx = (idx + 1) % this.windowSize;
    }

    values.sort((a, b) => a - b);
    return values[Math.floor(this.windowSize / 2)];
  }
}
